import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCloudArrow = () => {
  return (
    <g>
      <path d="m8.446 6.397.084.073 2.5 2.5a.75.75 0 0 1-.976 1.133l-.084-.073-1.22-1.219v5.439a.75.75 0 0 1-1.493.102l-.007-.102V8.811l-1.22 1.22a.75.75 0 0 1-.976.072l-.084-.073a.75.75 0 0 1-.073-.976l.073-.084 2.5-2.5a.75.75 0 0 1 .976-.073zM9.5 1a4.75 4.75 0 0 1 4.677 5.586l-.057.271-.013.046.113.06a3.499 3.499 0 0 1 1.757 2.64l.018.213.005.193a3.491 3.491 0 0 1-3.3 3.486l-.191.005H10.75a.75.75 0 1 1 0-1.5h1.759c1.05 0 1.91-.812 1.986-1.843l.005-.148c0-.922-.63-1.717-1.511-1.936a.75.75 0 0 1-.507-1.027 3.25 3.25 0 1 0-6.1-2.213.75.75 0 0 1-1.07.453l-.217-.136a1.25 1.25 0 0 0-1.716 1.654l.12.212a.75.75 0 0 1-.494 1.048 1.998 1.998 0 0 0 .346 3.93L3.5 12h1.75a.75.75 0 1 1 0 1.5H3.5a3.5 3.5 0 0 1-3.495-3.308L0 10c0-1.217.626-2.308 1.597-2.936l.175-.107.063-.034-.02-.08-.036-.195-.022-.198-.007-.2a2.75 2.75 0 0 1 3.18-2.717l.209.042.12.033.094-.177a4.753 4.753 0 0 1 3.692-2.41l.236-.016L9.5 1z" />
    </g>
  );
};

export default withIcon(IconCloudArrow);
